module.exports = __webpack_public_path__ + "static/media/ss.3c65b7fb.svg";